import { render, staticRenderFns } from "./FormSubdomain.vue?vue&type=template&id=78ad4520&scoped=true&"
import script from "./FormSubdomain.vue?vue&type=script&lang=js&"
export * from "./FormSubdomain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ad4520",
  null
  
)

export default component.exports